import { Field as DigdirField, FieldAffix, FieldAffixes, FieldCounter, FieldDescription, } from "@digdir/designsystemet-react";
const Field = DigdirField;
Field.displayName = "Field";
export { Field, FieldAffix, FieldAffixes, FieldCounter, FieldDescription, };
//# sourceMappingURL=field.js.map